import { generateJSON } from '@tiptap/html';
import { factoryExtensions } from '../components/Editor/useExtensions';
import {
  EditorState,
  ExtensionsConfigOptions,
} from '../components/Editor/types';
import { SchemaVersion } from '../server/types';

export const fromWriterHtml = (
  html: string,
  extensionConfig: ExtensionsConfigOptions
): EditorState => {
  const extensions = factoryExtensions(extensionConfig, {});
  return {
    version: SchemaVersion.V1,
    document: generateJSON(html, extensions),
  };
};
